// types
import {DefaultConfigProps} from '../types';

// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/dashboard';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 240;
export const RIGHT_DRAWER_WIDTH = 474;
export const RIGHT_MINI_DRAWER_WIDTH = 40;
export const MINI_DRAWER_WIDTH = 60;
export const HEADER_HEIGHT = '0px';
export const BOARD_HEADER_HEIGHT = '50px';

export enum SimpleLayoutType {
    SIMPLE = 'simple',
    LANDING = 'landing',
}

export enum ThemeMode {
    LIGHT = 'light',
    DARK = 'dark',
    AUTO = 'auto',
}

export enum MenuOrientation {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
}

export enum ThemeDirection {
    LTR = 'ltr',
    RTL = 'rtl',
}

export enum NavActionType {
    FUNCTION = 'function',
    LINK = 'link',
}

export enum Gender {
    MALE = 'Male',
    FEMALE = 'Female',
}

export enum DropzoneType {
    DEFAULT = 'default',
    STANDARD = 'standard',
}

// ==============================|| THEME CONFIG ||============================== //
const config: DefaultConfigProps = {
    fontFamily: `'Roboto', sans-serif`,
    i18n: 'en',
    menuOrientation: MenuOrientation.VERTICAL,
    menuCaption: true,
    miniDrawer: false,
    container: false,
    mode: ThemeMode.LIGHT,
    presetColor: 'theme1',
    themeDirection: ThemeDirection.LTR,
    themeContrast: false,
};

export default config;
